import { render, staticRenderFns } from "./RegisterOptions.vue?vue&type=template&id=c010370e&scoped=true&"
import script from "./RegisterOptions.vue?vue&type=script&lang=js&"
export * from "./RegisterOptions.vue?vue&type=script&lang=js&"
import style0 from "./RegisterOptions.vue?vue&type=style&index=0&id=c010370e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c010370e",
  null
  
)

/* custom blocks */
import block0 from "./RegisterOptions.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports